import React, { useEffect, useState } from 'react'
import guestPassengerApi from '../../../api/guestPassengerApi';
import { Box, Card, CardContent, Divider, Stack, Typography } from '@mui/material';

const PassengerInfo = ({ id }) => {
    const [loading, setLoading] = useState(true);
    const [memberInfo, setMemberInfo] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res1 = await guestPassengerApi.GetById(id);
                setMemberInfo(res1.data.data)
            } catch (error) {
                console.error("API error:", error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <Stack spacing={1}>
             {memberInfo?.name && (
            <Typography variant="body1">
              <strong> نام:</strong> {memberInfo.name}
            </Typography>
          )}
          {memberInfo?.family && (
            <Typography variant="body1">
              <strong> نام خانوادگی:</strong> {memberInfo.family}
            </Typography>
          )}
          {memberInfo?.mobileNO && (
            <Typography variant="body1">
              <strong>شماره همراه:</strong> {memberInfo.mobileNO}
            </Typography>
          )}
          {memberInfo?.emailAddress && (
            <Typography variant="body1">
              <strong>ایمیل:</strong> {memberInfo.emailAddress}
            </Typography>
          )}
          {memberInfo?.address && (
            <Typography variant="body1">
              <strong>آدرس:</strong> {memberInfo.address}
            </Typography>
          )}
        </Stack>   
    )
}

export default PassengerInfo